var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequestProfileReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.618,
    height: 39.107,
    viewBox: "0 0 34.618 39.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Request_Profile_Reviews",
    "data-name": "Request Profile Reviews",
    transform: "translate(10645 13158.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alms-hand-palm-right",
    transform: "translate(-10645 -13134.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M8.4,11.4V1h4.68a17.553,17.553,0,0,1,5.95,2.679h3.634c1.645.1,2.508,1.767.907,2.863-1.273.935-2.955.882-4.68.727a.783.783,0,1,0,0,1.544c.431.034.9-.068,1.307-.068,2.15,0,3.922-.414,5.007-2.113l.544-1.271,5.407-2.679c2.7-.89,4.629,1.938,2.634,3.908a70.834,70.834,0,0,1-12.039,7.086,8.152,8.152,0,0,1-8.948,0L8.4,11.4ZM0,0H7V12.447H0V0Z",
    fill: "#3e3e3e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M12.047,13.553A6.776,6.776,0,1,0,5.271,6.776,6.778,6.778,0,0,0,12.047,13.553Zm6.024,1.506H15.478a8.192,8.192,0,0,1-6.861,0H6.024A6.023,6.023,0,0,0,0,21.082v.753a2.259,2.259,0,0,0,2.259,2.259H21.835a2.259,2.259,0,0,0,2.259-2.259v-.753A6.023,6.023,0,0,0,18.071,15.059Z",
    transform: "translate(-10636.707 -13158.804)",
    fill: "#3e3e3e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestProfileReviews);
export default __webpack_public_path__ + "static/media/RequestProfileReviews.eff26ef8cb183ad76d81ad6b3805aae7.svg";
export { ForwardRef as ReactComponent };